export const zh = {
  // 通用
  common: {
    control: '控制',
    close: '✕',
    fullscreen: '浏览器全屏',
    exitFullscreen: '退出全屏',
    screenSize: '屏幕尺寸',
    inches: '英寸',
    currentMeasurement: '当前测量',
    diagonal: '对角线',
    window: '窗口',
    fullscreenMode: '全屏',
  },

  // 设备类型
  deviceType: {
    phone: '手机',
    tablet: '平板',
    display: '显示器',
  },

  // 控制面板
  controls: {
    title: '控制',
    brand: '品牌',
    model: '型号',
    selectBrand: '选择品牌',
    selectModel: '选择型号',
    screenSizeInches: '屏幕尺寸 (英寸)',
    mobileTip: '💡 移动端已自动适配屏幕尺寸',
    unit: '单位',
    centimeters: '厘米',
    inches: '英寸',
  },

  // 品牌
  brands: {
    iPhone: 'iPhone',
    Samsung: 'Samsung',
    Xiaomi: 'Xiaomi',
    Huawei: 'Huawei',
    OPPO: 'OPPO',
    vivo: 'vivo',
    OnePlus: 'OnePlus',
    iPad: 'iPad',
    other: '其他',
    custom: '自定义尺寸',
  },

  // 语言检测
  languageDetection: {
    title: '语言检测',
    detected: '我们检测到您可能在',
    switchTo: '切换到',
    stay: '保持英语',
    switch: '切换',
  },

  // 尺寸信息
  measurement: {
    current: '当前测量',
    width: '宽度',
    height: '高度',
    diagonal: '对角线',
    pixels: '像素',
  },
}; 